<script>
    import { onMount } from "svelte";
    import { warning_colour, warning_days, warning_date, show_settings } from "./stores";

    let colourBorders = {
        red: "black solid 1px",
        yellow: "black solid 1px",
        orange: "black solid 1px",

    };

    function passWC(event) {
        let colour = event.target.value
        pickWarningColour(colour)
    }

    function pickWarningColour(colour) {
        colourBorders[$warning_colour] = "black solid 1px";
        colourBorders[colour] = "black solid 3px";
        colourBorders = colourBorders;
        $warning_colour = colour;
    }

    function checkWarning(event) {
        let value = event.target.value
        if (value < 1) {
            event.target.value = 1
        }
    }

    $: {
        $warning_date = new Date(Date.now() - $warning_days * 24 * 60 * 60 * 1000);

    }

    onMount(() => {
        pickWarningColour($warning_colour);
    });

</script>

<div>
    {#if $show_settings}
        <div class="sider">
            <p>Warning days:</p>
            <input type="number" on:change={checkWarning} min="1" bind:value={$warning_days}>
        </div>

        <div class="sider">
            <div>
                <p>Warning colour:</p>
            </div>
            <div class="colourpicker">
                <button
                    on:click={passWC} value="red"
                    style="background: red; border: {colourBorders["red"]}"
                    />
                    <button
                    on:click={passWC} value="yellow"
                    style="background: yellow; border: {colourBorders["yellow"]}"
                    />
                    <button
                    on:click={passWC} value="orange"
                    style="background: orange; border: {colourBorders["orange"]}"
                />
            </div>
        </div>
    {/if}
</div>

<style>
    div.colourpicker button {
        height: 25px;
        width: 25px;
        content: "";
    }
    input[type=number] {
        max-width: 75px;
    }
</style>
